import React from 'react';
import swatchStyles from './swatch.module.pcss';

interface SwatchProps {
  swatch: string;
}

function Swatch({ swatch }: SwatchProps): React.ReactElement {
  return swatch.search(':') !== -1 ? (
    <div className={swatchStyles.swatch}>
      <div key={swatch} style={{ background: swatch.split(':')[0] }} className={swatchStyles['swatch__split']} />
      <div key={swatch} style={{ background: swatch.split(':')[1] }} className={swatchStyles['swatch__split']} />
    </div>
  ) : (
    <div key={swatch} style={{ background: swatch }} className={swatchStyles.swatch} />
  );
}

export default Swatch;
